import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { verificarCodigo2FA } from "./services";
import { confirmarAtivacao2FA } from "../services";
import { toast } from "sonner";

interface Verificar2FAState {
  status: "idle" | "loading" | "success" | "error"; 
  error: string | null;
  userData: any | null;
}

const initialState: Verificar2FAState = {
  status: "idle",
  error: null,
  userData: null,
};


export const verificar2FA = createAsyncThunk<
  any,
  { login: string; code: string },
  { rejectValue: string }
>("auth/verificar2FA", async ({ login, code }, { rejectWithValue }) => {
  try {
    const data = await verificarCodigo2FA(login, code);
    return data;
  } catch (err: any) {
    return rejectWithValue(err.message || "O código de verificação é inválido.");
  }
});

export const verificarEAtivar2FA = createAsyncThunk<
  { message: string },
  { code: string; secretKey: string },
  { rejectValue: string }
>("auth/verificarEAtivar2FA", async ({ code, secretKey }, { rejectWithValue }) => {
  try {
    const data = await confirmarAtivacao2FA(code, secretKey);
    return data;
  } catch (err: any) {
    return rejectWithValue(err.message || "O código de verificação é inválido.");
  }
});

const verificar2faSlice = createSlice({
  name: "verificar2fa",
  initialState,
  reducers: {
    resetVerificar2FAState: (state) => {
      state.status = "idle";
      state.error = null;
      state.userData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verificar2FA.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(verificar2FA.fulfilled, (state, action) => {
        state.status = "success";
        state.userData = action.payload; 
        state.error = null;
      })
      .addCase(verificar2FA.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload ?? "Ocorreu um erro inesperado.";
      })
      .addCase(verificarEAtivar2FA.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(verificarEAtivar2FA.fulfilled, (state) => {
        state.status = "success";
        state.error = null;
      })
      .addCase(verificarEAtivar2FA.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload ?? "Ocorreu um erro inesperado.";
      });
  },
});

export const { resetVerificar2FAState } = verificar2faSlice.actions;
export default verificar2faSlice.reducer;